import React, { Component, Fragment } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';

class QuickSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }

    getResultsSortedByCategory(result) {
        const categories = result.reduce((acc, resultItem) =>
            acc.indexOf(resultItem.category) === -1 ?
                acc.concat([resultItem.category]) :
                acc, []);
        const sortedByCategory = categories.map(category => {
            const items = result.filter(resultItem => resultItem.category === category);
            return { category, items };
        });
        return sortedByCategory;
    }

    render() {
        const { query, result, showResult, showFullForm, onSearch, onBlur, toggleShowFullForm, handleKeyDown, selectedItem } = this.props;

        const searchUrl = window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '');
        return (
            <div className="quick-search" role="search" ref={(elem) => this.searchContainer = elem}>
                <a className="quick-search__link--block" onClick={e => { toggleShowFullForm(); this.focusOnInput(), onSearch(''); }}>
                    <i className="quick-search__icon"></i>
                    <span className="quick-search__title">{translate('general.search')}</span>
                </a>
                <div className={`quick-search__form ${showFullForm ? 'quick-search__form--force-show' : ''}`} role="search">
                    <div className="row">
                        <div className="small-12 columns">
                            <div className="quick-search__input-wrap">
                                <input className="quick-search__input" type="search" placeholder={translate('general.search')}
                                    autoComplete="off" value={query} onChange={event => onSearch(event.target.value)}
                                    onKeyDown={event => handleKeyDown(event, { searchUrl })} ref={(input) => { this.searchInput = input; }}
                                    onBlur={() => onBlur()} 
                                />
                                <i className="quick-search__close-icon" onClick={e => { toggleShowFullForm(); onSearch(''); }}></i>
                                <i className="quick-search__magnifier-icon"></i>
                            </div>
                            {/* <button className="quick-search__submit-button" type="submit">
                                <i className="quick-search__submit-icon"></i>
                                <span className="quick-search__submit-title">{translate('general.search')}</span>
                            </button> */}
                        </div>
                    </div>
                </div>
                {showResult && showFullForm ? (
                    <QuickSearchResult
                        result={this.getResultsSortedByCategory(result)}
                        selectedItem={selectedItem} searchUrl={searchUrl}
                    />
                )
                    : null
                }
            </div>
        )
    }
}

export default QuickSearch;